// extracted by mini-css-extract-plugin
export default {"tabs":"NewDebates_tabs__sYcSg"};